import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../components/ui/tooltip";

/**
 * AttributeValueBlock - Renders a single block representing an attribute value.
 * Uses a single neutral color (gray) for all blocks to avoid visual confusion.
 *
 * @param {Object} props
 * @param {string} props.value - The value to display
 * @param {number} props.index - Index in the sequence
 */
const AttributeValueBlock = ({ value, index }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className="flex-shrink-0 px-3 py-1.5 rounded bg-gray-200 text-gray-800 text-xs font-medium cursor-default transition-transform hover:scale-105"
            style={{ maxWidth: "200px" }}
          >
            <span className="truncate block">{value}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent side="top">
          {value}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default AttributeValueBlock;
